import React from "react";
import { trackError } from "@src/utils/userActivityTracker";
import { SignolUtils } from "@src/utils";
import ErrorApp from "../layout/ErrorApp";

class ErrorBoundary extends React.Component {
  state = { hasError: false, errorMessage: "" };

  constructor(props) {
    super(props);
    this.state = { hasError: !!props.error, errorMessage: "" };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    let errorMessage = error.message;
    if (error.stack) {
      const errorLines = error.stack.split("\n").slice(0, 2);
      if (errorLines.length > 1) {
        // prettier format
        errorMessage = `${errorLines[0].trim()} ${errorLines[1].trim()}`; // "SomeError: xyz is not defined at ExampleComponent"
      }
    }
    return { hasError: true, errorMessage };
  }

  // This only handles errors that occur during UI rendering, lifecycle methods, or constructors of components.
  // It will NOT catch errors thrown by React Router loaders or actions.
  componentDidCatch(error, info) {
    this.logErrorToActivityService(error, info.componentStack);
    SignolUtils.removeSessionCookies();
  }

  logErrorToActivityService(error, componentStack) {
    console.error(error, { componentStack });
    trackError(error, undefined, {
      componentStack,
      catchingElement: "ErrorBoundary",
    });
  }

  render() {
    if (this.state.hasError || this.props.error) {
      console.log(
        "Error boundary - ",
        this.state.errorMessage || this.props.error?.message,
      );
      return <ErrorApp />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
